export const TEST_ID = 'batteryCard';
